import React, { useState } from 'react'

// components
import SideViewModal from '../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import ProcessEquipmentRequest from './ProcessEquipmentRequest.form'

// queries
import { useMutation } from '@apollo/client'
import { PROCESS_EQUIPMENT_REQUEST } from '../../../graphql/equipmentRequest/equipmentRequest.mutations.js'
import { apolloClient } from '../../..'
import { GET_EQUIPMENT_REQUEST_BY_ID_FOR_PROCESSING, GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS, GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES, GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO, GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS } from '../../../graphql/equipmentRequest/equipmentRequest.queries'

// utils
import { validate } from '../../../shared/utility'
import { createSubmitData, formatPrefillData } from './ProcessEquipmentRequest.form.controller.utils'

const validationSchema = {
    truck: {
        type: 'input',
        validation: {
            required: true
        }
    },
    equipment: {
        type: 'list',
        fields: {
            id: {
                type: 'input',
                validation: {
                    required: true
                }
            },
            sentQuantity: {
                type: 'input',
                validation: {
                    required: true,
                    maxAmountField: 'maxQuantity'
                }
            }
        }
    }
}

export default function ProcessEquipmentRequestFormController({ visible, closeForm, requestId }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [request, setRequest] = useState(null)
    const [processRequest] = useMutation(PROCESS_EQUIPMENT_REQUEST, {
        refetchQueries: [
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS, variables: { id: parseInt(requestId) }},
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO, variables: { id: parseInt(requestId) }},
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS, variables: { id: parseInt(requestId) }},
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES, variables: { id: parseInt(requestId) }},
        ]
    })
    const [errors, setErrors] = useState({ equipment: []})

    const handleSubmit = (formData) => {

        const { isValid, errors } = validate(formData, validationSchema)

        if(isValid) {
            processRequest({ variables: {...createSubmitData(requestId, formData)}}).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({ equipment: []})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
    }

    if(visible && isFetchingObject) {
        // fetch the data
        apolloClient.query({ query: GET_EQUIPMENT_REQUEST_BY_ID_FOR_PROCESSING, variables: { id: parseInt(requestId) }}).catch(e => {
            console.error(e)
        }).then(result => {
            if(result) {
                const prefillData = {
                    notes: result.data.equipmentRequest.notes ? result.data.equipmentRequest.notes : "",
                    job: {...result.data.equipmentRequest.job},
                    requestedBy: {...result.data.equipmentRequest.requestedBy},
                    equipment: [...formatPrefillData(result.data.equipmentRequest.equipmentRequestItemsForEquipmentRequest)],
                    truck: result.data.equipmentRequest.truck ? result.data.equipmentRequest.truck.id : null
                }
                setRequest(prefillData)
                setIsFetchingObject(false)
            }
        })

        return (null)
    }

    else if(visible) {
        const variants = [
            {
                name: 'Process Equipment Request',
                component: <ProcessEquipmentRequest requestId={requestId} />,
                stages: 2
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Mark as Shipped'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ equipment: []})
                closeForm()
            }} 
            title='Process Equipment Request'
            variants={variants}    
            prefillData={request}
            errors={errors}
            />)
    }

    return null
}